export default function isUndefinedValue(value) {
  return value === undefined || typeof value === 'string' && value.indexOf('undefined') !== -1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/isUndefinedValue.js
// module id = 706
// module chunks = 0